var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9871 17.0048C7.9871 17.0048 14.3804 15.069 14.3804 9.73234C14.3804 4.39484 14.6121 3.97817 14.0996 3.46484C13.5863 2.9515 8.82543 1.2915 7.9871 1.2915C7.14876 1.2915 2.38793 2.9515 1.87543 3.46484C1.3621 3.97817 1.59376 4.39484 1.59376 9.73234C1.59376 15.069 7.9871 17.0048 7.9871 17.0048Z",
    stroke: "#99AEA2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82159 8.89544L7.39826 10.4746L10.6466 7.22461",
    stroke: "#99AEA2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.9317384b3943c32a0a3b735b923d30a8.svg";
export { ForwardRef as ReactComponent };